<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h5>Перегрузить базу данных "Плавні пуски" из Excel</h5>
                <div class="flex" style="gap: 20px;">
                    <p-fileupload
                        mode="basic"
                        name="source"
                        :url="route('api.vector.upload_plavni_spusky')"
                        accept="application/*"
                        @upload="onUpload"
                        @error="onError"
                        @before-upload="beforeUpload"
                    ></p-fileupload>
                    <b style="color:red; text-decoration:underline;" v-if="plavni_spusky">{{ plavni_spusky.file_name }} ({{ moment(plavni_spusky.created_at).format("DD.MM.YYYY HH:mm") }})</b>
                    <b v-if="plavni_spusky">{{ plavni_spusky.user.email }}</b>
                    <textarea style="width:400px;" v-if="plavni_spusky" v-model="plavni_spusky.comment" v-on:keyup.enter="updateHistoryComment(plavni_spusky.id, plavni_spusky.comment, 'plavni_spusky')" placeholder="Комментарий"></textarea>
                </div>
                <br>
                <ProgressBar mode="indeterminate" style="height: .5em" v-if="progress" />
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import moment from "moment";
import Input from '../Jetstream/Input.vue';
import axios from "axios";

export default {
    layout: AppLayout,
    props: {
        plavni_spusky: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            moment: moment,
            progress: false,
            progressKrm: false,
            progressCatalog: false,
            progressCatalogName: false,
        }
    },
    components: {
        ProgressBar,
        "p-fileupload": FileUpload,
        "p-toast": Toast,
        Input
    },
    methods: {
        onUpload() {
            this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded'});
            this.progress = false;
            location.reload();
        },
        onError(event) {
            let errorMessage = 'Upload Error';
            try {
                let jsonResponse = JSON.parse(event.xhr.response);
                errorMessage = jsonResponse.message
            } catch (error) {
            }

            this.$toast.add({severity: 'error', summary: 'Error', detail: errorMessage});
            this.progress = false;
        },
        beforeUpload() {
            this.progress = true;
        },
        
        updateHistoryComment(id, text, type) {
            axios.post(this.route('api.update_history'), {id: id, comment: text, type: type})
            .then((result) => {
                this.$toast.add({severity: 'info', summary: 'Success', detail: 'Comment updated', life: 3000});
            }).catch((error) => {
                console.log(error);
            })
        }
    }
};
</script>
